/**
 * Dropdown Module
 * 
 * This module creates custom dropdown menus using the Select2 jQuery plugin.
 */

import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;
import select2 from 'select2';
select2($);

let _selectors = {
    selectInput: '.js-dropdown',
    gravitySelectInput: '.gfield_select',
};

// Cached Elements.
let _el = {};

// Module Variables
let _vars = {};

// Module init
const _init = () => {
    // Define & Cache Elements
    _setElements();

    _bindEvents();
};

const _bindEvents = () => {
    // target all els with class .js-dropdown
    if($(_el.selectInput).length) {
        $(_el.selectInput).select2({
            minimumResultsForSearch: Infinity,
            selectionCssClass: 'option-selected',
            allowClear: true,
            placeholder: {
                text: $(this).attr,
                selected: 'selected'
            }
        });

        // mark element as interacted with unless showing placeholder option
        $(_el.selectInput).on('change', function() {
            if(!$(this).val() == '') {
                $(this).addClass('interacted');
            } else {
                $(this).removeClass('interacted');
            }
        });
        
        // reset select2 elements on form reset event
        $( "#post-filter" ).on( "reset", function() {
            $(_el.selectInput).val('').trigger('change')
        });
    }

    // gravity form select2
    if($(_el.gravitySelectInput).length) {
        $(_el.gravitySelectInput).select2({
            minimumResultsForSearch: Infinity,
            selectionCssClass: 'option-selected',
            allowClear: true,
            templateResult: function(data, container) {
                if (data.element) {
                  $(container).addClass($(data.element).attr("class"));
                }
                return data.text;
            }
        });

        // mark element as interacted with unless showing placeholder option
        $(_el.gravitySelectInput).on('change', function() {
            if(!$(this).val() == '') {
                $(this).addClass('interacted');
            } else {
                $(this).removeClass('interacted');
            }
        });
    }
};

// Set/Reset and Cache Module elements
const _setElements = () => {
    // Cache Elements into _el & create variable to check existence
    Object.keys(_selectors).forEach(key => {
        const el = document.querySelectorAll(_selectors[key]);
        _el[key] = el;
        _vars[key] = el.length;
    });
};

const Dropdown = {
    init: _init,
};

export default Dropdown;